import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import type { FeatureCollection } from 'geojson';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = window.env.MAPBOX_ACCESS_TOKEN;

interface DashboardMapProps {
  mapData?: FeatureCollection;
}

const DashboardMapDynamic: React.FC<DashboardMapProps> = ({ mapData }) => {
  const mapContainerRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    if (mapData) {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current as HTMLElement,
        style: 'mapbox://styles/developer-novarum/cm7j8wqxo00l601s28qe64pnx',
        center: [21.0, 2.0],
        zoom: 2,
      });

      map.addControl(new mapboxgl.NavigationControl(), 'top-right');

      map.on('load', () => {
        // Add your local GeoJSON data as a source
        map.addSource('myData', {
          type: 'geojson',
          data: mapData,
          cluster: true,
          clusterMaxZoom: 14,
          clusterRadius: 50,
          clusterMinPoints: 5
        });

        // Add a layer to render the points with colors based on final_result_interpretation
        map.addLayer({
          id: 'points',
          type: 'circle',
          source: 'myData',
          paint: {
            'circle-radius': 7,
            'circle-color': [
              'match',
              ['get', 'final_result_interpretation'],
              'POSITIVE', '#F40003',
              'NEGATIVE', '#93C47D',
              'BORDERLINE', '#DAA520',
              'INVALID', '#b8b9c7',
              /* default */ '#000000'
            ],
            'circle-stroke-width': 1,
            'circle-stroke-color': '#fff',
          },
        });
      });

      return () => map.remove();
    }
  }, [mapData]);

  return mapData ? (
    <div style={{ position: 'relative' }}>
      <div ref={mapContainerRef} style={{ width: '100%', height: '530px' }} />
      {/* Legend */}
      <div style={{
        position: 'absolute',
        bottom: 10,
        right: 10,
        background: 'rgba(255,255,255,0.9)',
        padding: '10px',
        borderRadius: '4px',
        fontSize: '12px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
          <span style={{ backgroundColor: '#93C47D', width: '15px', height: '15px', display: 'inline-block', marginRight: '8px' }}></span>
          POSITIVE
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
          <span style={{ backgroundColor: '#F40003', width: '15px', height: '15px', display: 'inline-block', marginRight: '8px' }}></span>
          NEGATIVE
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
          <span style={{ backgroundColor: '#DAA520', width: '15px', height: '15px', display: 'inline-block', marginRight: '8px' }}></span>
          BORDERLINE
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
          <span style={{ backgroundColor: '#b8b9c7', width: '15px', height: '15px', display: 'inline-block', marginRight: '8px' }}></span>
          INVALID
        </div>
      </div>
    </div>
  ) : (null);
};

export default DashboardMapDynamic;
